import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Grid,
  Checkbox,
  FormControlLabel,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export default function OrderStatus() {
  const progressData = [
    {
      status: "Order Placed",
      location: "New York, USA",
      date: "August 29, 2020",
      time: "2:00 pm",
    },
    {
      status: "Documentation Prepared",
      location: "New York, USA",
      date: "August 29, 2020",
      time: "3:30 pm",
    },
    {
      status: "Booking Arranged",
      location: "New York, USA",
      date: "August 29, 2020",
      time: "3:35 pm",
    },
    {
      status: "Collected",
      location: "New York, USA",
      date: "August 29, 2020",
      time: "4:00 pm",
    },
    {
      status: "In Transit to Destination",
      location: "New York, USA",
      date: "August 29, 2020",
      time: "6:00 pm",
    },
    {
      status: "Arrived at Destination",
      location: "London, United Kingdom",
      date: "",
      time: "",
    },
    {
      status: "Out for Delivery",
      location: "London, United Kingdom",
      date: "",
      time: "",
    },
    {
      status: "Delivered",
      location: "London, United Kingdom",
      date: "",
      time: "",
    },
  ];

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        bgcolor: "#EEF2FF",
        p: 3,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Card sx={{ padding: 2, display: "flex", alignItems: "center" }}>
        <Box sx={{ padding: 4, backgroundColor: "#f7f8fc" }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ marginBottom: 2, color: "#222" }}
          >
            Track order
          </Typography>

          {/* Search Section */}
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                variant="outlined"
                size="small"
                placeholder="#6548"
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Button
                variant="contained"
                color="success"
                fullWidth
                sx={{ textTransform: "none" }}
              >
                Search
              </Button>
            </Grid>
          </Grid>

          {/* Order Details */}
          <Grid container spacing={2} marginTop={4}>
            <Grid item xs={12} md={5}>
              <Card elevation={2}>
                <CardContent>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Order No:</strong> #6548
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Customer name:</strong> Kiran
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Customer No:</strong> 91 0987654321
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Shipped via:</strong> UPS Ground
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Shipped on:</strong> August 29, 2020, 6:00 pm
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Destination:</strong> London, United Kingdom
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 1 }}>
                    <strong>Expected date:</strong> September 4, 2020
                  </Typography>
                  <Typography variant="body1" sx={{ marginBottom: 2 }}>
                    <strong>Status:</strong>{" "}
                    <span style={{ color: "#28a745", fontWeight: "bold" }}>
                      In Transit
                    </span>
                  </Typography>
                  <FormControlLabel
                    control={<Checkbox color="success" defaultChecked />}
                    label="Notify me when order is delivered"
                  />
                </CardContent>
              </Card>
            </Grid>

            {/* Agent Details */}
            <Grid item xs={12} md={7}>
              <Card elevation={2}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <Typography>
                        <strong>Agent name:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>Ravi</Typography>
                    </Grid>

                    <Grid item xs={4}>
                      <Typography>
                        <strong>Phone number:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>91 1234567890</Typography>
                    </Grid>

                    <Grid item xs={4}>
                      <Typography>
                        <strong>Area:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Typography>USA</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/* Order Progress */}
              <Box sx={{ marginTop: 3 }}>
                <Typography variant="h6" fontWeight="bold">
                  Status
                </Typography>
                <Divider sx={{ marginBottom: 2 }} />
                <TableContainer component={Paper} elevation={0}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Location</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Time</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {progressData.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell
                            sx={{
                              color: index < 5 ? "#28a745" : "#ccc",
                              fontWeight: index < 5 ? "bold" : "normal",
                            }}
                          >
                            {row.status}
                          </TableCell>
                          <TableCell>{row.location}</TableCell>
                          <TableCell>{row.date || "--"}</TableCell>
                          <TableCell>{row.time || "--"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Card>
    </Box>
  );
}
